<template>
	<div class="pa-3">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-form ref="form" class="pb-5">
			<v-tabs v-model="active" color="grey lighten-5">
				<v-tab :key="1" ripple>"Know Your Skin" Contents</v-tab>
				<v-tab :key="2" ripple>Tips</v-tab>

				<v-tab-item :key="1">
					<v-card>
						<v-card-text>
							<pinned-contents :community-id="1"></pinned-contents>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item :key="2">
					<v-card>
						<v-card-text>
							<tips :community-id="1"></tips>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>
		</v-form>
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import PinnedContents from '@/views/skincare-community/tabs/PinnedContents.vue'
	import Tips from '@/views/skincare-community/tabs/Tips.vue'

	export default {
		components: {
			'pinned-contents': PinnedContents,
			'tips': Tips,
		},
		data () {
			return {
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: config.PUBLIC_PATH
					},
					{
						text: 'Skincare Community',
						disabled: true,
						href: null
					}
				],
				active: null,
				rules: {
					text: [
						v => !!v || 'Field is required'
					],					
					number: [
						v => !!v || 'Field is required',
						v => (parseInt(v) > 0) || 'Value must be greater than 0'
					],					
				},
				publicPath: (process.env.NODE_ENV === 'production') ? config.PUBLIC_PATH : '/'
			}
		}
	}
</script>
